
export function calcTotalAmount(tab: number[]) {
  const sumWithInitial = tab.reduce(
    (accumulator: number, curVal: number) => accumulator + curVal,
    0
  )
  return sumWithInitial
}
